import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { DIRECTIONS } from './_constants';

export const ChevronOutlinedIcon = ({
  width,
  height,
  fill,
  className,
  direction,
  ...rest
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='64 64 896 896'
      width={width}
      height={height}
      className={clsx('icon', 'icon-chevron-outlined', className, {
        'icon-chevron-outlined--up': direction === DIRECTIONS.UP,
        'icon-chevron-outlined--right': direction === DIRECTIONS.RIGHT,
        'icon-chevron-outlined--down': direction === DIRECTIONS.DOWN,
        'icon-chevron-outlined--left': direction === DIRECTIONS.LEFT
      })}
      {...rest}
    >
      <path
        fill={fill}
        d='M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'
      />
    </svg>
  );
};

ChevronOutlinedIcon.defaultProps = {
  width: 15,
  height: 15,
  fill: 'currentColor',
  className: '',
  direction: 'up'
};

ChevronOutlinedIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(DIRECTIONS))
};
